export default "__VITE_PUBLIC_ASSET__fcc0eaa5__"